import axios from "../services/api/api";
import { useQuery } from "@tanstack/react-query";

// INVOICE QUERIES
const FetchInvoiceHistory = async () => {
  const res = await axios.get("/Shop/MyOrders");
  return res.data.result;
};
export function GetInvoiceHistory() {
  return useQuery({
    queryKey: ["FetchInvoiceHistory"],
    queryFn: () => FetchInvoiceHistory(),
    retry: 3,
  });
}

//SCHOOLQUERIES
const FetchSchoolDataBySchoolId = async (schoolId) => {
  const res = await axios.get(`/school/GetSchoolData/${schoolId}`);
  return res.data.result;
};
export function GetSchoolDataBySchoolId(schoolId) {
  return useQuery({
    queryKey: ["FetchSchoolDataBySchoolId", schoolId],
    queryFn: () => FetchSchoolDataBySchoolId(schoolId),
    retry: 3,
    enabled: !!schoolId,
  });
}

//TEACHERQUERIES
const FetchTeacherInformation = async () => {
  const res = await axios.get(`/Teacher/ByEmail`);
  if (typeof res !== "undefined") {
    if (res.data.result.programmes && res.data.result.customer) {
      localStorage.setItem("schoolName", res.data.result.customer.name);

      localStorage.setItem("school", JSON.stringify(res.data.result.customer));
    }
    return res.data.result;
  }
};
export function GetTeacherInformation(opt = {}) {
  return useQuery({
    queryKey: ["FetchTeacherInformation"],
    queryFn: () => FetchTeacherInformation(),
    retry: 3,
    ...opt,
  });
}

const FetchTeacherStudents = async () => {
  const email = localStorage.getItem("email");
  const res = await axios.get(
    `/Teacher/Students?teacherEmail=${encodeURIComponent(email)}&showActiveOnly=false`,
  );
  return res.data.result;
};
export function GetTeacherStudents(opt = {}) {
  return useQuery({
    queryKey: ["FetchTeacherStudents"],
    queryFn: () => FetchTeacherStudents(),
    retry: 3,
    ...opt,
  });
}

const FetchTeacherInfoById = async (teacherId) => {
  const res = await axios.get(`/Teacher/${teacherId}`);
  return res.data.result;
};
export function GetTeacherInfoById(teacherId) {
  return useQuery({
    queryKey: ["FetchTeacherInfoById", teacherId],
    queryFn: () => FetchTeacherInfoById(teacherId),
  });
}

const FetchAvailableModuleAnswers = async () => {
  const res = await axios.get(`/Module/GetAvailableModuleAnswers`);
  return res.data.result;
};

export function GetAvailableModuleAnswers() {
  return useQuery({
    queryKey: ["FetchAvailableModuleAnswers"],
    queryFn: () => FetchAvailableModuleAnswers(),
  });
}

//PROGRAMQUERIES
const FetchProgramById = async (programId) => {
  const res = await axios.get(`/programme/${programId}`);
  return res.data.result;
};
export function GetProgramById(programId) {
  return useQuery({
    queryKey: ["FetchProgramById", programId],
    queryFn: () => FetchProgramById(programId),
    retry: 3,
  });
}

const FetchResultsByProgramId = async (programId) => {
  const res = await axios.get(
    `/Course/GetCoursesWithResultsByProgram/${programId}`,
  );
  return res.data.result;
};
export function GetResultsByProgramId(programId, opt = {}) {
  return useQuery({
    queryKey: ["FetchResultsByProgramId", programId],
    queryFn: () => FetchResultsByProgramId(programId),
    retry: 3,
    ...opt,
  });
}

//CLASSQUERIES
const FetchClassByClassId = async (classId) => {
  const res = await axios.get(`/Class/GetByClassId/${classId}`);
  return res.data.result;
};
export function GetClassByClassId(classId) {
  return useQuery({
    queryKey: ["FetchClassByClassId", classId],
    queryFn: () => FetchClassByClassId(classId),
    retry: 3,
    enabled: !!classId,
  });
}

const FetchCoursesByClassId = async (classId) => {
  const res = await axios.get(
    `/Course/GetCoursesWithResultsByClass/${classId}`,
  );
  return res.data.result;
};
export function GetCoursesByClassId(classId, opt = {}) {
  return useQuery({
    queryKey: ["FetchCoursesByClassId", classId],
    queryFn: () => FetchCoursesByClassId(classId),
    retry: 3,
    ...opt,
  });
}

//APLQUERIES
// Note: Many APL queries support level-based filtering using the 'level' parameter
// which can be "Program", "Class", or "Student". The appropriate endpoint is
// selected based on the level, and the id parameter is interpreted accordingly:
// - Program: id = programId
// - Class: id = classId
// - Student: id = studentId

const FetchSupervisors = async (schoolId) => {
  const res = await axios.get(
    `/Apl/GetSupervisorsForSchool?schoolId=${schoolId}`,
  );
  return res.data.result;
};
export function GetSupervisors(schoolId) {
  return useQuery({
    queryKey: ["FetchSupervisors", schoolId],
    queryFn: () => FetchSupervisors(schoolId),
    retry: 3,
  });
}

const FetchSupervisorCompanies = async () => {
  const res = await axios.get(`/Apl/GetCompanies`);
  return res.data.result;
};
export function GetSupervisorCompanies() {
  return useQuery({
    queryKey: ["FetchSupervisorCompanies"],
    queryFn: () => FetchSupervisorCompanies(),
    retry: 3,
  });
}

const FetchWorkCards = async () => {
  const res = await axios.get(`/Apl/GetWorkCards`);
  return res.data.result;
};
export function GetWorkCards() {
  return useQuery({
    queryKey: ["FetchWorkCards"],
    queryFn: () => FetchWorkCards(),
    retry: 3,
  });
}

const FetchAvailableStudentsForPeriod = async (data) => {
  if (data.candidates.candidateStudentIds.length > 0) {
    const res = await axios.post(
      `/Apl/GetStudentsPossibleToAdd`,
      data.candidates,
    );
    return res.data.result;
  } else return [];
};

export function GetAvailableStudentsForPeriod(data) {
  return useQuery({
    queryKey: ["FetchAvailableStudentsForPeriod", { data }],
    queryFn: () => FetchAvailableStudentsForPeriod(data),
    retry: 3,
  });
}

const FetchPeriods = async (level, id) => {
  let res = { data: { result: null } };
  if (level === "Program") {
    res = await axios.get(`/Apl/GetPeriodsByProgram/?programId=${id}`);
  } else if (level === "Class") {
    res = await axios.get(`/Apl/GetPeriodsByClass/?classId=${id}`);
  } else if (level === "Student") {
    res = await axios.get(`/Apl/GetPeriodsByStudent/?studentId=${id}`);
  }
  return res.data.result;
};

export function GetPeriods(level, id) {
  return useQuery({
    queryKey: ["FetchPeriods", [level, id]],
    queryFn: () => FetchPeriods(level, id),
    retry: 3,
  });
}

const FetchEvents = async (level, periodId, objectId) => {
  let res = { data: { result: [] } };
  if (!periodId) {
    return res;
  } else {
    if (level === "Program") {
      res = await axios.get(
        `/Apl/GetStudentEventsProgram?periodId=${periodId}&programId=${objectId}`,
      );
    } else if (level === "Class") {
      res = await axios.get(
        `/Apl/GetStudentEventsClass?periodId=${periodId}&classId=${objectId}`,
      );
    } else if (level === "Student") {
      res = await axios.get(
        `/Apl/GetStudentEventsStudent?periodId=${periodId}&studentId=${objectId}`,
      );
    }
    return res.data.result;
  }
};

export function GetEvents(level, periodId, objectId) {
  return useQuery({
    queryKey: ["FetchEvents", [level, periodId, objectId]],
    queryFn: () => FetchEvents(level, periodId, objectId),
    retry: 3,
  });
}

const FetchWorkCardHours = async (level, periodId, objectId) => {
  let res = null;
  if (!periodId) {
    return res;
  } else {
    if (level === "Program") {
      res = await axios.get(
        `/Apl/GetWorkCardHoursByProgramAndPeriod/?programId=${objectId}&periodId=${periodId}`,
      );
    } else if (level === "Class") {
      res = await axios.get(
        `/Apl/GetWorkCardHoursByClassAndPeriod/?classId=${objectId}&periodId=${periodId}`,
      );
    } else if (level === "Student") {
      res = await axios.get(
        `/Apl/GetWorkCardHoursByStudentAndPeriod/?studentId=${objectId}&periodId=${periodId}`,
      );
    }
    return res.data.result;
  }
};

export function GetWorkCardHours(level, periodId, objectId) {
  return useQuery({
    queryKey: ["FetchWorkCardHours", [level, periodId, objectId]],
    queryFn: () => FetchWorkCardHours(level, periodId, objectId),
    retry: 3,
  });
}

const FetchAttendanceStatuses = async (level, periodId, objectId) => {
  let res = null;
  if (!periodId) {
    return res;
  } else {
    if (level === "Program") {
      res = await axios.get(
        `/Apl/GetAttendanceStatusForProgram/?programId=${objectId}&periodId=${periodId}`,
      );
    } else if (level === "Class") {
      res = await axios.get(
        `/Apl/GetAttendanceStatusForClass/?classId=${objectId}&periodId=${periodId}`,
      );
    } else if (level === "Student") {
      res = await axios.get(
        `/Apl/GetAttendanceStatusForStudent/?studentId=${objectId}&periodId=${periodId}`,
      );
    }
    return res.data.result;
  }
};

export function GetAttendanceStatuses(level, periodId, objectId) {
  return useQuery({
    queryKey: ["FetchAttendanceStatuses", [level, periodId, objectId]],
    queryFn: () => FetchAttendanceStatuses(level, periodId, objectId),
    retry: 3,
  });
}

const FetchFoodCompensationStatus = async (studentId, periodId) => {
  if (periodId) {
    const res = await axios.get(
      `/Apl/GetFoodCompensationRequiredDaysForStudent?studentId=${studentId}&periodId=${periodId}`,
    );
    return res.data.result;
  } else return null;
};

export function GetFoodCompensationStatus(studentId, periodId) {
  return useQuery({
    queryKey: ["FetchFoodCompensationStatus", [studentId, periodId]],
    queryFn: () => FetchFoodCompensationStatus(studentId, periodId),
    retry: 3,
  });
}

const FetchEvaluationQuestions = async (periodId) => {
  if (periodId) {
    const res = await axios.get(
      `/Apl/GetEvaluationQuestions?periodId=${periodId}`,
    );
    return res.data.result;
  } else return null;
};

export function GetEvaluationQuestions(periodId) {
  return useQuery({
    queryKey: ["FetchEvaluationQuestions", periodId],
    queryFn: () => FetchEvaluationQuestions(periodId),
    retry: 3,
  });
}

const FetchRatingSummary = async (periodId, level, objId) => {
  if (!periodId) return null;
  const res = await axios.get(
    `/Apl/GetRatingSummary?periodId=${periodId}&level=${level}&objId=${objId}`,
  );
  return res.data.result;
};

export function GetRatingSummary(periodId, level, objId) {
  return useQuery({
    queryKey: ["FetchRatingSummary", [periodId, level, objId]],
    queryFn: () => FetchRatingSummary(periodId, level, objId),
    retry: 3,
    enabled: !!periodId,
  });
}

//STUDENTQUERIES

const FetchStudentInfoByStudentId = async (studentId) => {
  const res = await axios.get("/student/?id=" + studentId);
  return res.data.result;
};
export function GetStudentInfoByStudentId(studentId) {
  return useQuery({
    queryKey: ["FetchStudentInfoByStudentId", studentId],
    queryFn: () => FetchStudentInfoByStudentId(studentId),
    retry: 3,
  });
}

const FetchCoursesByStudentEmail = async (studentEmail) => {
  if (studentEmail !== null) {
    const res = await axios.get(
      "/student/Courses?email=" + encodeURIComponent(studentEmail),
    );
    return res.data.result;
  }
  return null;
};
export function GetCoursesByStudentEmail(studentEmail) {
  return useQuery({
    queryKey: ["FetchCoursesByStudentEmail", studentEmail],
    queryFn: () => FetchCoursesByStudentEmail(studentEmail),
    retry: 1,
  });
}

const FetchCoursesWithResultsByStudentId = async (studentId) => {
  const res = await axios.get(
    `/Course/GetCoursesWithResultsByStudent/${studentId}`,
  );
  return res.data.result;
};
export function GetCoursesWithResultsByStudentId(studentId, opt = {}) {
  return useQuery({
    queryKey: ["FetchCoursesWithResultsByStudentId", studentId],
    queryFn: () => FetchCoursesWithResultsByStudentId(studentId),
    retry: 3,
    ...opt,
  });
}

//RESULTQUERIES
const FetchBestAndLatestStudentResultAnalysisData = async (
  studentId,
  courseId,
  moduleId,
) => {
  if (studentId === null || courseId === null || moduleId === null) {
    return null;
  }
  const res = await axios.get(
    `/Teacher/BestAndLatestStudentResultAnalysis?studentId=${studentId}&courseId=${courseId}&moduleId=${moduleId}`,
  );
  return res.data.result;
};
export function GetBestAndLatestStudentResultAnalysisData(
  studentId,
  courseId,
  moduleId,
) {
  return useQuery({
    queryKey: [
      "FetchBestAndLatestStudentResultAnalysisData",
      { studentId, courseId, moduleId },
    ],
    queryFn: () =>
      FetchBestAndLatestStudentResultAnalysisData(
        studentId,
        courseId,
        moduleId,
      ),
    retry: 3,
  });
}

const FetchBestAndLatestStudentResultAnalysisDataForGy25FinalExamVariant =
  async (studentId, variantId) => {
    if (studentId === null || variantId === null) {
      return null;
    }
    const res = await axios.get(
      `/Teacher/StudentResultAnalysisFinalExam?studentId=${studentId}&variantId=${variantId}`,
    );
    return res.data.result;
  };
export function GetBestAndLatestStudentResultAnalysisDataForGy25FinalExamVariant(
  studentId,
  variantId,
) {
  return useQuery({
    queryKey: [
      "FetchBestAndLatestStudentResultAnalysisDataForGy25FinalExamVariant",
      { studentId, variantId },
    ],
    queryFn: () =>
      FetchBestAndLatestStudentResultAnalysisDataForGy25FinalExamVariant(
        studentId,
        variantId,
      ),
    retry: 3,
  });
}

const FetchClassResultAnalysisData = async (classId, courseId, moduleId) => {
  if (classId === null || courseId === null || moduleId === null) {
    return null;
  }
  const res = await axios.get(
    `/Teacher/ClassResultAnalysis?classId=${classId}&courseId=${courseId}&moduleId=${moduleId}`,
  );
  return res.data.result;
};
export function GetClassResultAnalysisData(classId, courseId, moduleId) {
  return useQuery({
    queryKey: ["FetchClassResultAnalysisData", { classId, courseId, moduleId }],
    queryFn: () => FetchClassResultAnalysisData(classId, courseId, moduleId),
    retry: 3,
  });
}

const FetchFinalExamVariantsForCourse = async (classId, courseId) => {
  if (classId == null || courseId == null) return null;

  const res = await axios.get(
    `/Course/GetFinalExamVariantsForCourse?classId=${classId}&courseId=${courseId}`,
  );
  return res.data.result;
};
export function GetFinalExamVariantsForCourse(classId, courseId) {
  return useQuery({
    queryKey: ["FetchFinalExamVariantsForCourse", classId, courseId],
    queryFn: () => FetchFinalExamVariantsForCourse(classId, courseId),
    retry: 3,
  });
}

//TODO FETCH FOR FINALEXAMVARIANT
const FetchClassResultAnalysisDataGy25FinalExam = async (variantId) => {
  if (variantId === null) {
    return null;
  }
  const res = await axios.get(
    `/Teacher/ClassResultAnalysisFinalExam?finalExamVariantId=${variantId}`,
  );
  return res.data.result;
};
export function GetClassResultAnalysisDataGy25FinalExam(variantId) {
  return useQuery({
    queryKey: ["FetchClassResultAnalysisDataGy25FinalExam", { variantId }],
    queryFn: () => FetchClassResultAnalysisDataGy25FinalExam(variantId),
    retry: 3,
  });
}

const FetchUnviewedWorkRegistrationCountsByPeriod = async () => {
  const res = await axios.get(`/Apl/GetUnviewedWorkRegistrationCountsByPeriod`);
  return res.data.result;
};

export function GetUnviewedWorkRegistrationCountsByPeriod() {
  return useQuery({
    queryKey: ["FetchUnviewedWorkRegistrationCountsByPeriod"],
    queryFn: () => FetchUnviewedWorkRegistrationCountsByPeriod(),
    retry: 3,
    refetchOnWindowFocus: true,
    staleTime: 30000,
    refetchInterval: 60000,
  });
}

const FetchSupportRequestCategories = async () => {
  const res = await axios.get("/SupportRequest/Categories");
  return res.data.result;
};
export function GetSupportRequestCategories() {
  return useQuery({
    queryKey: ["FetchSupportRequestCategories"],
    queryFn: () => FetchSupportRequestCategories(),
    retry: 3,
  });
}
